import login from './login';

export default {
  auth: {
    pages: {
      ...login,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/auth/index.js